module.exports = __webpack_public_path__ + "img/ic_cash.84a2f772.svg";